export const typeInvoice = [
    { id: 1, name: 'Member & ScanQR' },
    { id: 2, name: 'Service' },
    { id: 3, name: 'Agency' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeInvoice.js